var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    _vm._g(
      {
        ref: "cell",
        staticClass: "cell column-filter",
        style: _vm.filterRowTop,
        attrs: {
          id: _vm.uid,
          contenteditable: "",
          ondragenter:
            "event.preventDefault(); event.dataTransfer.dropEffect = 'none'",
          ondragover:
            "event.preventDefault(); event.dataTransfer.dropEffect = 'none'",
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "off",
          spellcheck: "false",
          tabindex: "-1",
        },
        on: {
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          keydown: [
            function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 37) {
                return null
              }
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.keyWest.apply(null, arguments)
            },
            function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 39) {
                return null
              }
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.keyEast.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.keyEnter.apply(null, arguments)
            },
          ],
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                "Backspace",
                "Delete",
                "Del",
              ])
            ) {
              return null
            }
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            ) {
              return null
            }
            return _vm.keyDelete.apply(null, arguments)
          },
          mousemove: _vm.mouseMove,
          mousedown: _vm.mouseDown,
        },
      },
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }